export default __webpack_public_path__ + "static/media/doc.e1f7c87d.gif";